import script from './component-lib.esm7.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.rootComponent, _vm._b({
    tag: "component",
    staticClass: "v-product",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'component', _vm.$attrs, false), [_c('Paper', {
    staticClass: "v-product__img",
    attrs: {
      "color": "gray200",
      "hideStaticShadow": ""
    }
  }, [_c('div', {
    staticClass: "v-product__img__inner"
  }, [_vm._t("image", function () {
    return [_c('img', {
      attrs: {
        "src": _vm.image || _vm.noImageSrc,
        "alt": _vm.imageAlt || 'Product image',
        "loading": "lazy",
        "draggable": "false"
      }
    })];
  })], 2), _vm._v(" "), _vm.isInGroup ? _c('span', {
    staticClass: "v-product__check"
  }, [_c('CheckIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSelected,
      expression: "isSelected"
    }],
    attrs: {
      "color": "primary",
      "size": "1.5rem"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "v-product__info"
  }, [_c('VText', {
    staticClass: "v-product__name",
    attrs: {
      "variant": "h3"
    }
  }, [_vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.title))];
  })], 2), _vm._v(" "), _c('VText', {
    staticClass: "v-product__price"
  }, [_vm._t("price", function () {
    return [_vm._v(_vm._s(_vm.formattedPrice))];
  })], 2)], 1)], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-c322b676_0", {
    source: ".v-product[data-v-c322b676]{background:0 0;border:none;display:flex;flex-direction:column;padding:0;position:relative;text-align:center;text-decoration:none}.v-product--link[data-v-c322b676]{cursor:pointer}.v-product--link:focus .v-product__img img[data-v-c322b676],.v-product--link:hover .v-product__img img[data-v-c322b676]{transform:scale(1.05)}.v-product--selected .v-product__img[data-v-c322b676]:after{border-color:var(--g-color-primary)}.v-product__img[data-v-c322b676],.v-product__img img[data-v-c322b676],.v-product__img__inner[data-v-c322b676]{width:100%;height:100%}.v-product__img[data-v-c322b676]{margin-bottom:1rem;height:200px}.v-product__img[data-v-c322b676]:after{content:\"\";border:.125rem solid transparent;border-radius:inherit;position:absolute;left:-.25rem;top:-.25rem;height:calc(100% + .5rem);width:calc(100% + .5rem);transition:var(--g-transition-speed)}.v-product__img__inner[data-v-c322b676]{border-radius:inherit;overflow:hidden}.v-product__img img[data-v-c322b676]{border-radius:inherit;object-fit:contain;transition:transform var(--g-duration-complex)}.v-product__info[data-v-c322b676]{padding-left:.5rem;padding-right:.5rem;width:100%}.v-product__check[data-v-c322b676]{position:absolute;top:.25rem;right:.25rem;z-index:1}.v-product__name.v-product__name[data-v-c322b676]{font-size:1rem;margin-bottom:.25rem}.v-product__img.v-product__img[data-v-c322b676]{background-color:var(--g-color-gray-200);border:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-c322b676";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var VProduct = __vue_component__;
export { VProduct as default };